/**
 * author: Ananthapadmanabhan V K
 */
import React from 'react';
import './InvalidRoutePage.scss';
import { withTranslation } from 'react-i18next';

const InvalidRoutePage = ({ t }) => {
  return (
    <div className="InvalidRoutePage">
      <div className="mainbox">
        <div className="err">4</div>
        <div className="err2">0</div>
        <div className="err3">4</div>
        <div className="msg">Not Found</div>
      </div>
    </div>
  )
};

export default withTranslation()(InvalidRoutePage);
